import { render, staticRenderFns } from "./BirdOrbit.vue?vue&type=template&id=4fa71bf6&scoped=true"
import script from "./BirdOrbit.vue?vue&type=script&lang=js"
export * from "./BirdOrbit.vue?vue&type=script&lang=js"
import style0 from "./BirdOrbit.vue?vue&type=style&index=0&id=4fa71bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa71bf6",
  null
  
)

export default component.exports